import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import history from "../../auth/history";
import moment from "moment";
import { Link } from "react-router-dom";
import { store } from '../../redux/store';
import tokenErrorHandler from "../tokenErrorHandler";
import { totalActiveConsumers, totalConsumerNo, totalInActiveConsumers } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class AllCustomerDetailsSubComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			consumerList: [],
			keys: []
		}
	}


	componentDidMount() {

		var totalAmount=0;
        var totalActives = 0;
		var totalInactives = 0;
		var url = '/api/v1/billpay/corp/consumer/get-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}

		httpClient.get(url + this.props.agentInfo+'/all/all',
			{ headers }
		).then((response) => {


			this.setState({
				consumerList: response.data
			})

			if (response.data != undefined) {
				store.dispatch(totalConsumerNo(response.data.length));
			}

			var list = [];

			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.map(res => {

					if (res.optional != null) {
						const map = new Map(Object.entries(res.optional));

						var mapKeys = [...map.keys()];

						var optionMap = {
							key: '',
							value: '',
							id: ''
						}
						mapKeys.map(key => {
							optionMap.key = key;
							optionMap.value = map.get(key);
							optionMap.id = res.id;
						})

						list.push(optionMap)

					}

					if (res.active == true) {
						totalActives = totalActives + 1;
					} else {
						totalInactives = totalInactives + 1;
					}
					if (res.currentBillPayAmount != undefined &&
						res.currentBillPayAmount > 0
					) {
						totalAmount = totalAmount + res.lcurrentBillPayAmount;
					}


				})
				store.dispatch(totalActiveConsumers(totalActives));
				store.dispatch(totalInActiveConsumers(totalInactives));

				this.setState({
					keys: list
				})
			}


		}).catch(error => {
			
			store.dispatch(totalConsumerNo(0));
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		});
	}
	componentWillUnmount() {
	}




	render() {

		return (
			<div class="col-12 col-lg-4">
				<div class="card">
					<div class="dashhead">
						<h3>Added Consumer</h3>
						<Link to="/all-consumer" class="lbbtn">View all</Link>
					</div>

					<div class="addedlist">
						{this.state.consumerList.length > 0 &&
							this.state.consumerList.slice(0, 3).map(consumer => (
								<div class="addedcard">
									<div class="consumr">
										{/* <img src="images/dhbvn.png" alt="biller" /> */}
										<h5>{consumer.consumerName}</h5>
										{/* {this.state.keys.length} */}
										{this.state.keys.length > 0 &&

											this.state.keys.map(key => (
												(
													key.id == consumer.id &&
													<p>{key.key.split("_").join(" ")} : {key.value}</p>
												)
											))

										}
										<p></p>

									</div>
									<div class="consumr">
										<h4 class={consumer.active == true ? "active" : "inactive"}>Consumer Name : {consumer.consumerName} ; AgentId: {consumer.agentId}</h4>
										<p>+91-{consumer.mobileNo}</p>
										<p class="date">Created On : {moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss')}</p>
									</div>
								</div>
							))
						}
					</div>



					{/* <div class="addedcard">
							<div class="consumr">
								<img src="images/bses.png" alt="biller" />
								<h5>New Delhi Municipal Council - NDMC</h5>
								<p>Consumer No. 9876543217</p>
							</div>
							<div class="consumr">
								<h4 class="active">Ramesh Swamy, Branch ID: FNX12345</h4>
								<p>+91-9898989898</p>
								<p class="date">12-11-2021 16:09:23</p>
							</div>
						</div>

						<div class="addedcard">
							<div class="consumr">
								<img src="images/indane.png" alt="biller" />
								<h5>IOCL - Indane Gas - New Delhi</h5>
								<p>Consumer No. 4562347890</p>
							</div>
							<div class="consumr">
								<h4 class="active">Ankit Agrawal, Branch ID: FNX12345</h4>
								<p>+91-9898989898</p>
								<p class="date">12-11-2021 16:09:23</p>
							</div>
						</div> */}
				</div>
			</div>

		);
	}
}


const mapStateToProps = (
	{ errorMessageReduce: { errorMessage,  },
		miscReduce: {  phone, agentInfo,clientRole,token} }
) => ({
	errorMessage,  phone, agentInfo,clientRole,token
});

export default connect(mapStateToProps, null)(AllCustomerDetailsSubComponent);
